import React, { Component, PropTypes } from 'react';
import FormControl from './FormControl';

export default class TextInput extends Component {
  static propTypes = {
    value: PropTypes.string
  };

  static defaultProps = {
    value: null
  };

  focus = () => this.refs.input.focus();

  render() {
    const { value, ...rest } = this.props;

    return (
      <FormControl>
        <input ref="input" type="text" value={value || ''} {...rest}/>
      </FormControl>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/inputs/TextInput.jsx